import { subDays } from 'date-fns';
import React, { useState } from 'react';
import { MetricTypeEnum } from '../../../../../../enums/MetricTypeEnum';

import { Container, Content, Header, HeaderItems } from './styles';
import DateFilter from './DateFilter';
import MetricView from './MetricView';

type MetricsType = {
  key: MetricTypeEnum;
  abbreviation: string;
  title: string;
  measure?: string;
};

export type DateRangeType = {
  startDate: Date;
  endDate: Date;
};
export type OptionsType = {
  key: 'today' | 'week' | 'month' | 'specific';
  title?: string;
  rangeDate: DateRangeType;
};

const EvolutionModal: React.FC = () => {
  const metrics: MetricsType[] = [
    {
      key: MetricTypeEnum.BLOOD_PREASSURE,
      abbreviation: 'Pressão',
      title: 'Pressão Arterial (mmHg)',
      measure: 'mmHg',
    },
    {
      key: MetricTypeEnum.HEART_BEAT_RATE,
      abbreviation: 'Coração',
      title: 'Batimento Cardíaco (bpm)',
      measure: 'bpm',
    },
    {
      key: MetricTypeEnum.BODY_TEMPERATURE,
      abbreviation: 'Temperatura',
      title: 'Temperatura (ºC)',
      measure: 'ºC',
    },
    {
      key: MetricTypeEnum.BLOOD_OXYGEN,
      abbreviation: 'Oxigenação',
      title: 'Oxigênio (SpO2%)',
      measure: 'SpO2%',
    },
    {
      key: MetricTypeEnum.SLEEP,
      abbreviation: 'Sono',
      title: 'Sono (Horas dormidas)',
    },
    {
      key: MetricTypeEnum.CALORIES,
      abbreviation: 'Caloria',
      title: 'Calorias (Kcal)',
    },
    {
      key: MetricTypeEnum.STEPS,
      abbreviation: 'Passos',
      title: 'Passos',
    },
    {
      key: MetricTypeEnum.RESPIRATORY_RATE,
      abbreviation: 'Respiração',
      title: 'Frequência Respiratória (mrm)',
      measure: 'mrm',
    },
    {
      key: MetricTypeEnum.GLUCOSE,
      abbreviation: 'Glic',
      title: 'Glicose (mg/dL)',
    },
  ];

  const [metricSelected, setMetricSelected] = useState<MetricsType>(metrics[0]);

  const today = new Date();
  const options: OptionsType[] = [
    {
      key: 'today',
      title: 'Hoje',
      rangeDate: {
        startDate: today,
        endDate: today,
      },
    },
    {
      key: 'week',
      title: 'Essa semana',
      rangeDate: {
        startDate: subDays(today, 6),
        endDate: today,
      },
    },
    {
      key: 'month',
      title: 'Mês',
      rangeDate: {
        startDate: subDays(today, 29),
        endDate: today,
      },
    },

    {
      key: 'specific',
      title: 'Específico',
      rangeDate: {
        startDate: new Date(),
        endDate: new Date(),
      },
    },
  ];

  const [selectedDateOption, setSelectedDateOption] = useState<OptionsType>(
    options[0],
  );

  return (
    <Container>
      <Header>
        <h1>Evolução</h1>
        <HeaderItems>
          {metrics.map((item) => (
            <button
              key={item.key}
              type="button"
              onClick={() => setMetricSelected(item)}
              disabled={metricSelected.key === item.key}
            >
              {item.abbreviation}
            </button>
          ))}
        </HeaderItems>
        <DateFilter
          options={options}
          updateDateRange={setSelectedDateOption}
          dateRange={selectedDateOption}
        />
      </Header>

      <Content>
        <h3>{metricSelected.title}</h3>
        <MetricView
          selectedDateOption={selectedDateOption}
          updateDateOption={setSelectedDateOption}
          options={options}
          metric={metricSelected.key}
        />
      </Content>
    </Container>
  );
};

export default EvolutionModal;
